import { render, staticRenderFns } from "./OurRD.vue?vue&type=template&id=75e7ff05&scoped=true"
import script from "./OurRD.vue?vue&type=script&lang=js"
export * from "./OurRD.vue?vue&type=script&lang=js"
import style0 from "./OurRD.vue?vue&type=style&index=0&id=75e7ff05&prod&lang=scss&scoped=true"
import style1 from "./OurRD.vue?vue&type=style&index=1&id=75e7ff05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e7ff05",
  null
  
)

export default component.exports